import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors } from '@/components/ui/types';

import { DividerDirection, DividerPosition, DividerProps } from './types';

const directionClasses: Record<DividerDirection, string> = {
  horizontal: 'divider-horizontal',
  vertical: 'divider-vertical',
};

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'divider-neutral',
  primary: 'divider-primary',
  secondary: 'divider-secondary',
  accent: 'divider-accent',
  info: 'divider-info',
  success: 'divider-success',
  warning: 'divider-warning',
  error: 'divider-error',
};

const positionClasses: Record<DividerPosition, string> = {
  start: 'divider-start',
  center: '',
  end: 'divider-end',
};

export const Divider = forwardRef<HTMLDivElement, DividerProps>(
  (
    {
      className,
      direction,
      color = 'default',
      position = 'center',
      children,
      ...props
    },
    ref,
  ) => {
    const classes = twMerge(
      'divider',
      direction && directionClasses[direction],
      colorClasses[color],
      positionClasses[position],
      className,
    );

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  },
);

Divider.displayName = 'Divider';
